import React, { Component } from 'react';

class Banner extends Component {
	render() {
		return (
			<section className="review">
				<div className="container-fluid">
					<div className="review__section">
						<div className="total__review">
							<p className="total d-inline-block mr-2">4.5</p>
							<div className="review__section__stars d-inline-block">
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star-o"></i>
							</div>
						</div>
						<span>- 106 Reviews</span>
						<button className="btn btn-outline-primary review_btn">Write A Review</button>
						<div className="review__section__filter text-center">
							<div className="row">
								<div className="col-lg-2">
									<input type="text" className="form-control search" placeholder="Search" />
								</div>
								<div className="col-6 col-lg-2">
									<select className="form-control select">
										<option selected>20-24 yrs</option>
										<option value="1">24-25 yrs</option>
										<option value="2">25-26 yrs</option>
									</select>
								</div>
								<div className="col-6 col-lg-2">
									<select className="form-control select">
										<option selected>Skin Concern</option>
										<option value="1">Body Concern</option>
										<option value="2">Arm Concern</option>
									</select>
								</div>
								<div className="col-6 col-lg-2">
									<select className="form-control select">
										<option selected>Oily</option>
										<option value="1">Dry</option>
									</select>
								</div>
								<div className="col-6 col-lg-2">
									<select className="form-control select">
										<option selected>Sort By</option>
										<option value="1">Highest</option>
										<option value="2">Lowest</option>
									</select>
								</div>
								<div className="col-lg-2">
									<a href="">Clear filter</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="container-fluid">
					<div className="review__section">
						<div className="rating">
							<div className="d-flex flex-sm-row flex-column">
								<div className="buyer buyer__info">
									<div className="buyer__img">
										<img className="buyer" src="/images/buyer.png" />
										<img className="buyer__verified__tick" src="/images/verified.png" />
										<p className="buyer__verified">Verified Buyer</p>
									</div>
									<p>Julia Ng<br />Singapore <br />01/01/2020</p>
									<p>Age Range: 20-35 <br />Skin Type: Normal<br />Skin Concern: Acne, Redness</p>
								</div>
								<div className="rating__review">
									<div className="rating__stars">
										<div className="rating__stars__count">
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
										</div>
									</div>
									<h3 className="rating__review__title mt-3">I fell in love with yours from day one!</h3>
									<p>so I bought this product and liked it on my first few tries of the product. But I found that the product did sting when applied on particularly sore pimples. This did require me to wash my skin almost instantaneously. But it did clear my skin, for the most part, I have seen less visible acne and it did make my skin smoother but I don't think that it evened to softened my complexion. Overall I think that if you have particularly sensitive skin or sensitive acne to steer clear of this product or at least avoid those areas.</p>
									<p className="mt-sm-5 mt-2 mb-4">
										Was this review helpful &nbsp; &nbsp; &nbsp;  9 <img src="/images/up.svg" alt="" /> 0 <img src="/images/down.svg" alt="" />
									</p>
								</div>
							</div>
						</div>
						<div className="rating">
							<div className="d-flex flex-sm-row flex-column">
								<div className="buyer buyer__info">
									<div className="buyer__img">
										<img className="buyer" src="/images/buyer.png" />
										<img className="buyer__verified__tick" src="/images/verified.png" />
										<p className="buyer__verified">Verified Buyer</p>
									</div>
									<p>Julia Ng<br />Singapore <br />01/01/2020</p>
									<p>Age Range: 20-35 <br />Skin Type: Normal<br />Skin Concern: Acne, Redness</p>
								</div>
								<div className="rating__review">
									<div className="rating__stars">
										<div className="rating__stars__count">
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
										</div>
									</div>
									<h3 className="rating__review__title mt-3">I fell in love with yours from day one!</h3>
									<p>so I bought this product and liked it on my first few tries of the product. But I found that the product did sting when applied on particularly sore pimples. This did require me to wash my skin almost instantaneously. But it did clear my skin, for the most part, I have seen less visible acne and it did make my skin smoother but I don't think that it evened to softened my complexion. Overall I think that if you have particularly sensitive skin or sensitive acne to steer clear of this product or at least avoid those areas.</p>
									<p className="mt-sm-5 mt-2 mb-4">
										Was this review helpful &nbsp; &nbsp; &nbsp;  9 <img src="/images/up.svg" alt="" /> 0 <img src="/images/down.svg" alt="" />
									</p>
								</div>
							</div>
						</div>
						<div className="rating">
							<div className="d-flex flex-sm-row flex-column">
								<div className="buyer buyer__info">
									<div className="buyer__img">
										<img className="buyer" src="/images/buyer.png" />
										<img className="buyer__verified__tick" src="/images/verified.png" />
										<p className="buyer__verified">Verified Buyer</p>
									</div>
									<p>Julia Ng<br />Singapore <br />01/01/2020</p>
									<p>Age Range: 20-35 <br />Skin Type: Normal<br />Skin Concern: Acne, Redness</p>
								</div>
								<div className="rating__review">
									<div className="rating__stars">
										<div className="rating__stars__count">
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
										</div>
									</div>
									<h3 className="rating__review__title mt-3">I fell in love with yours from day one!</h3>
									<p>so I bought this product and liked it on my first few tries of the product. But I found that the product did sting when applied on particularly sore pimples. This did require me to wash my skin almost instantaneously. But it did clear my skin, for the most part, I have seen less visible acne and it did make my skin smoother but I don't think that it evened to softened my complexion. Overall I think that if you have particularly sensitive skin or sensitive acne to steer clear of this product or at least avoid those areas.</p>
									<p className="mt-sm-5 mt-2 mb-4">
										Was this review helpful &nbsp; &nbsp; &nbsp;  9 <img src="/images/up.svg" alt="" /> 0 <img src="/images/down.svg" alt="" />
									</p>
								</div>
							</div>
						</div>
						<div className="rating">
							<div className="d-flex flex-sm-row flex-column">
								<div className="buyer buyer__info">
									<div className="buyer__img">
										<img className="buyer" src="/images/buyer.png" />
										<img className="buyer__verified__tick" src="/images/verified.png" />
										<p className="buyer__verified">Verified Buyer</p>
									</div>
									<p>Julia Ng<br />Singapore <br />01/01/2020</p>
									<p>Age Range: 20-35 <br />Skin Type: Normal<br />Skin Concern: Acne, Redness</p>
								</div>
								<div className="rating__review">
									<div className="rating__stars">
										<div className="rating__stars__count">
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
											<i className="fa fa-star"></i>
										</div>
									</div>
									<h3 className="rating__review__title mt-3">I fell in love with yours from day one!</h3>
									<p>so I bought this product and liked it on my first few tries of the product. But I found that the product did sting when applied on particularly sore pimples. This did require me to wash my skin almost instantaneously. But it did clear my skin, for the most part, I have seen less visible acne and it did make my skin smoother but I don't think that it evened to softened my complexion. Overall I think that if you have particularly sensitive skin or sensitive acne to steer clear of this product or at least avoid those areas.</p>
									<p className="mt-sm-5 mt-2 mb-4">
										Was this review helpful &nbsp; &nbsp; &nbsp;  9 <img src="/images/up.svg" alt="" /> 0 <img src="/images/down.svg" alt="" />
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}


export default Banner;